import React from 'react';
import { Container } from 'react-bootstrap';

function ServicePolicy() {
  return (
    <Container className="my-5">
      <h1>服務條款</h1>
      <div className="mt-4">
        <p>
          歡迎您光臨琴語鋼琴網（以下簡稱「本網站」或「本平台」）。為保障您的權益，請您在使用本網站提供之各項服務前，詳閱下列服務條款（以下簡稱「本條款」）。當您註冊成為會員或使用本網站任何服務，即表示您已閱讀、瞭解並同意遵守本條款之所有內容。
        </p>
        <h2>1. 會員註冊</h2>
        <p>
          <ul>
            <li>您須提供正確、最新及完整的個人資料進行註冊。</li>
            <li>若您的資料有變更，請即時於網站更新，以維護您的權益。</li>
            <li>每位用戶僅能註冊一個帳號，不得重複註冊或冒用他人資料。</li>
            <li>您有責任妥善保管帳號與密碼，若帳號遭未經授權使用，請立即通知本公司。</li>
          </ul>
        </p>

        <h2>2. 服務內容</h2>
        <p>
          本平台提供線上商品瀏覽、購物、付款、售後服務等相關電商服務。
        </p>

        <h2>3. 訂單與契約成立</h2>
        <p>
          <ul>
            <li>當您於本平台完成商品下單程序，系統將自動發送訂單通知信，但該通知僅為通知您訂單已被系統接收，不代表買賣契約成立。</li>
            <li>本平台保留是否接受訂單的權利，如因系統錯誤或其他因素無法接受訂單，將通知您取消訂單並協助退款。</li>
          </ul>
        </p>

        <h2>4. 商品價格與付款方式</h2>
        <ul>
          <li>商品價格以您下單當下所顯示價格為準，並以新台幣計價。</li>
          <li>本平台提供以下付款方式：信用卡、ATM 轉帳、超商付款、貨到付款、第三方支付（如 LINE Pay、街口等）。</li>
          <li>若付款失敗或異常，系統將不予保留訂單。</li>
        </ul>

        <h2>5. 退換貨政策</h2>
        <ul>
          <li>本平台販售之琴譜商品屬於數位內容，依據《通訊交易解除權合理例外情事適用準則》第2條第9款，數位內容商品一經下載、開啟、或啟用，即視為使用完成，恕不接受退貨申請。消費者在購買前已充分理解並同意上述條件，並於結帳時確認其知悉本商品之性質與限制。</li>
          <li>若您需辦理退貨，請於7日內聯繫客服，我們將提供退貨流程。</li>
        </ul>

        <h2>6. 智慧財產權</h2>
        <p>
        本網站上之所有內容，包括但不限於圖片、商標、圖示、文字、設計、程式等，均屬本公司或合法權利人所有，未經授權不得轉載、修改、散布或用於商業用途。
        </p>

        <h2>7. 使用限制與終止</h2>
        <p>
        如您違反本條款、本平台有權暫停或終止您之會員資格，並保留相關法律追訴權利。 
        </p>
        <h2>8. 免責聲明</h2>
        <ul>
          <li>本平台對於因不可抗力、第三方非法行為或其他非可歸責於本公司之因素所造成之任何損失，不負賠償責任。</li>
          <li>本網站對外部連結之內容不負任何保證與責任。</li>
        </ul>
      </div>
    </Container>
  );
}

export default ServicePolicy;
